import React, { useState } from "react";
import { Button } from "@nextui-org/react";
import { TbCheck } from "react-icons/tb";

const BanksLedgerFooter = ({ finalBalance, onMarkAsPaid }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (finalBalance <= 0) {
      alert("No pending balance to mark as paid for this month.");
      return;
    }

    if (
      window.confirm(
        `Are you sure you want to mark dues of ₹${finalBalance.toLocaleString(
          "en-IN"
        )} as Paid?`
      )
    ) {
      try {
        setLoading(true);
        await onMarkAsPaid();
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "16px",
        marginTop: "20px",
      }}
    >
      <Button
        color="success"
        icon={<TbCheck />}
        onClick={handleClick}
        disabled={loading || finalBalance <= 0}
        css={{
          borderRadius: "24px",
          px: "32px",
          fontWeight: 700,
        }}
      >
        Mark as Paid
      </Button>
    </div>
  );
};

export default BanksLedgerFooter;
